import { render, staticRenderFns } from "./EmployeeRules.vue?vue&type=template&id=b374b30c&scoped=true&lang=pug"
import script from "./EmployeeRules.vue?vue&type=script&lang=js"
export * from "./EmployeeRules.vue?vue&type=script&lang=js"
import style0 from "./EmployeeRules.vue?vue&type=style&index=0&id=b374b30c&prod&lang=scss"
import style1 from "./EmployeeRules.vue?vue&type=style&index=1&id=b374b30c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b374b30c",
  null
  
)

export default component.exports